import { useMemo } from "react";

import { useGlobalAuthStore } from "@/stores/global/auth";
import filter from "@Components/Grid/utils/filter";

export default function useFilters() {
  const { auth } = useGlobalAuthStore()
  const userId = auth.currentSession?.user?.id

  return useMemo(() => [
    filter
      .options.store("tags", "Tags", "tags", TAG_OPTIONS_PARSER)
      .multi(true),
    filter
      .options.list("level", "Level", LEVEL_OPTIONS)
      .multi(true),
    filter
      .options.list("userId", "Owner", [{ label: "Mine", value: userId }]),
  ], [userId])
}

const TAG_OPTIONS_PARSER = {
  parserOptions: {
    labelKey: "tag",
    valueKey: "tag",
    formatter: name => name,
  },
}

const LEVEL_OPTIONS = [
  { label: "Site", value: "site" },
  { label: "Organization", value: "organization" },
]
